export const normalizeSwedishPhoneNumber = (input: string | null | undefined) => {
  const sanitized = String(input ?? '').replace(/[^\d+]/g, '');

  if (!sanitized) {
    return '';
  }

  if (sanitized.startsWith('+46')) {
    const localPart = sanitized.slice(3);
    return localPart.startsWith('0') ? `+46${localPart.slice(1)}` : `+46${localPart}`;
  }

  if (sanitized.startsWith('46')) {
    const localPart = sanitized.slice(2);
    return localPart.startsWith('0') ? `+46${localPart.slice(1)}` : `+46${localPart}`;
  }

  if (sanitized.startsWith('0')) {
    return `+46${sanitized.slice(1)}`;
  }

  return sanitized.startsWith('+') ? sanitized : `+${sanitized}`;
};
